import { MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useTranslation } from '../../../i18next';
import { useTheme } from '../../../themes';

export type TimeUnit = 'w' | 'd';
export const SelectTimeUnit = ({
  value,
  plural,
  onChange,
  fullWidth,
  error
}: {
  value: TimeUnit;
  plural: boolean;
  onChange: (nextValue: TimeUnit) => void;
  fullWidth?: boolean;
  error?: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Select
      variant="outlined"
      value={value}
      onChange={(ev) => {
        const nextUnit = ev.target.value as TimeUnit;
        return onChange(nextUnit);
      }}
      style={{ width: theme.spacing(15) }}
      error={error}
    >
      <MenuItem value="d">{plural ? t('Days') : t('Day')}</MenuItem>
      <MenuItem value="w">{plural ? t('Weeks') : t('Week')}</MenuItem>
    </Select>
  );
};
